import { Trash2 } from "lucide-react";

import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputNumber from "@/components/desktop/form/input/input-number/CustomInputNumber";

import { formatProductOption } from "@/components/desktop/products/product_option/formatProductOption";

import styles from "./PhytosanitaryApplicationProductRow.module.scss";

const typeDetailOptions = [
	{ value: "y", label: "y" },
	{ value: "o", label: "o" },
];

const PhytosanitaryApplicationProductRow = ({ product, lookups, onUpdate, onRemove, showRemove = true, isIrrigation = false, readOnly = false }) => {
	const handleProductChange = (value) => {
		const found = lookups?.products_customers?.find((option) => option.value === value);
		onUpdate("productID", value);
		onUpdate("activeIngredientText", found?.active_ingredient || "");
	};

	const doseField = isIrrigation ? (
		<div className={styles.field} style={{ flex: "0 0 9%" }}>
			<CustomInputNumber value={product.doseHa} onChange={(value) => onUpdate("doseHa", value)} placeholder="Dosis/Ha" size="sm" disabled={readOnly} />
		</div>
	) : (
		<div className={styles.field} style={{ flex: "0 0 9%" }}>
			<CustomInputNumber
				value={product.dose100L}
				onChange={(value) => onUpdate("dose100L", value)}
				placeholder="Dosis/100L"
				size="sm"
				disabled={readOnly}
			/>
		</div>
	);

	return (
		<div className={`${styles.row}${readOnly ? " " + styles.rowReadOnly : ""}`}>
			<div className={styles.field} style={{ flex: "0 0 14%" }}>
				<CustomInputSelect
					options={lookups?.objectives || []}
					value={product.objectiveID}
					onChange={(value) => onUpdate("objectiveID", value)}
					placeholder="Objetivo"
					isClearable
					size="sm"
					disabled={readOnly}
				/>
			</div>

			<div className={styles.field} style={{ flex: "0 0 18%" }}>
				<CustomInputSelect
					options={lookups?.products_customers || []}
					value={product.productID}
					onChange={handleProductChange}
					placeholder="Producto"
					isClearable
					size="sm"
					disabled={readOnly}
					formatOptionLabel={formatProductOption}
					async
					defaultOptions={false}
					minChars={2}
				/>
			</div>

			<div className={styles.field} style={{ flex: "0 0 9%" }}>
				<CustomInputSelect
					options={typeDetailOptions}
					value={product.typeDetail}
					onChange={(value) => onUpdate("typeDetail", value)}
					placeholder="y/o"
					isClearable
					size="sm"
					disabled={readOnly}
				/>
			</div>

			{doseField}

			<div className={styles.field} style={{ flex: "1 1 auto" }}>
				<CustomInputText
					value={product.observations}
					onChange={(value) => onUpdate("observations", value)}
					placeholder="Obs."
					size="sm"
					disabled={readOnly}
				/>
			</div>

			{showRemove && !readOnly && (
				<button type="button" className={styles.removeButton} onClick={onRemove} aria-label="Eliminar producto">
					<Trash2 size={14} />
				</button>
			)}
		</div>
	);
};

export default PhytosanitaryApplicationProductRow;
